import React from 'react';
import { TableTitle, Caption } from '@qover/typography';
import styled from 'styled-components';
import { FormattedCurrency } from '@qover/react-intl';
import { roundUpCurrency } from '@qover/utils/src/tools';

const OptionList = styled.ul`
  &&& {
    margin: 15px 0 0;
    padding: 0;
  }

  li {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
  &&& li {
    margin-top: 10px;
  }
  &&& li > *:first-child {
    width: auto;
  }
`;

const Container = styled.div`
  margin-bottom: 20px;
  &.with-border-top {
    border-top: 1px solid var(--color-text-quote-10);
    padding-top: 20px;
  }
`;

const OptionNameContainer = styled.div`
  align-items: center;
  display: flex;
  * + * {
    margin-left: 10px;
  }
  svg {
    max-width: 18px;
    max-height: 18px;
  }
`;

type SummaryOptionsProps = {
  included?: React.ReactNode;
  options?: Array<{
    'data-test': string;
    icon?: React.ReactNode;
    label: string | React.ReactNode;
    value: number;
  }>;
  paymentRythmMessage?: React.ReactNode;
  showTopSeparator?: boolean;
  title?: React.ReactNode;
};

export function SummaryPriceOptions(props: SummaryOptionsProps) {
  if (!props.options?.length && !props.included) {
    return null;
  }
  const { showTopSeparator = true } = props;

  return (
    <Container className={showTopSeparator ? 'with-border-top' : ''}>
      {props.title && (
        <Caption as="div" className="upper">
          {props.title}
        </Caption>
      )}
      <OptionList>
        {props.included}
        {props.options?.map((option, idx) => (
          <li key={idx}>
            <OptionNameContainer>
              {option.icon}
              <TableTitle as="div" className="bold">
                {option.label}
              </TableTitle>
            </OptionNameContainer>
            {option.value && (
              <TableTitle
                as="span"
                className="bold"
                data-test={option['data-test']}
              >
                <FormattedCurrency value={roundUpCurrency(option.value)} />{' '}
                {props.paymentRythmMessage}
              </TableTitle>
            )}
          </li>
        ))}
      </OptionList>
    </Container>
  );
}
